import React, { useCallback, useEffect, useState } from 'react';
import cx from 'classnames';

import { EmptyStateView, Label, Pagination } from '@atlas/ui';

import { PRIZES_PER_PAGE } from './shares';

const formatRank = rank => {
  if (`${rank}`.length === 1) return `0${rank}`;
  return rank;
};

const Prizes = ({ prizes = [], prizesPerPage = PRIZES_PER_PAGE }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedPrizes, setPaginatedPrizes] = useState([]);

  const paginate = useCallback(
    pageNumber => {
      setCurrentPage(pageNumber);
      const indexOfFirstPrize = (pageNumber - 1) * prizesPerPage;
      const indexOfLastPrize = indexOfFirstPrize + prizesPerPage;
      setPaginatedPrizes(prizes?.slice(indexOfFirstPrize, indexOfLastPrize));
    },
    [prizes, prizesPerPage],
  );

  const totalPages = Math.ceil(prizes?.length / prizesPerPage);

  useEffect(() => {
    paginate(currentPage);
  }, [prizes, currentPage, paginate]);

  const changePage = page => paginate(page + 1);

  const bodyCls = cx({
    'smartico-table-fixed-prize': totalPages > 1,
  });

  if (!prizes.length) {
    return (
      <EmptyStateView
        className="list-empty"
        description="smartico_tournaments_prize_pool_empty_description"
        title="smartico_tournaments_prize_pool_empty_title"
      />
    );
  }

  return (
    <div className="smartico-table">
      <div className="smartico-table-header">
        <Label
          className="smartico-table-header-title smartico-table-column-first"
          message="smartico_tournaments_prize_pool_rank"
        />
        <Label
          className="smartico-table-header-title smartico-table-column"
          message="smartico_tournaments_prize_pool_prize"
        />
      </div>
      <div className={bodyCls}>
        {paginatedPrizes.map((prize, index) => (
          <div className="smartico-table-row" key={index * 2}>
            <div className="smartico-table-text smartico-table-column-first">
              {prize.place_from === prize.place_to
                ? formatRank(prize.place_from)
                : `${formatRank(prize.place_from)} - ${formatRank(prize.place_to)}`}
            </div>
            <div className="smartico-table-score smartico-table-column">
              <div className="smartico-table-img smartico-table-img-prize">
                {!!prize.image_url && <img alt={prize.name} src={prize.image_url} />}
              </div>
              {!!prize.name && (
                <div className="smartico-leaderboard-score smartico-leaderboard-score-main">
                  {prize.name}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <Pagination changeCurrentPage={changePage} currentPage={currentPage - 1} pages={totalPages} />
    </div>
  );
};

export default Prizes;
